/**
 * 多项目上下文：请求头携带 user-guid + leasing-project-guid
 */
import Vue from 'vue'
import auth from '@/utils/auth'

const STAFF_KEY = 'patrol-demo-staff-guid'
const PROJECT_KEY = 'patrol-current-project-guid'

/** 响应式，供菜单/权限 computed 订阅 */
export const authState = Vue.observable({
  context: null,
  loading: false
})

export function getStaffGuid() {
  return localStorage.getItem(STAFF_KEY) || auth.getStoredStaffGuid() || ''
}

export function setStaffGuid(guid) {
  if (guid) localStorage.setItem(STAFF_KEY, guid)
  else localStorage.removeItem(STAFF_KEY)
}

export function getProjectGuid() {
  const v = localStorage.getItem(PROJECT_KEY)
  return v === 'ALL' ? null : (v || null)
}

export function setProjectGuid(guid) {
  if (!guid) localStorage.setItem(PROJECT_KEY, 'ALL')
  else localStorage.setItem(PROJECT_KEY, guid)
}

export function getContext() {
  return authState.context
}

export function clearContext() {
  authState.context = null
}

export async function loadContext(apiGetAuthContext) {
  authState.loading = true
  try {
    const ctx = await apiGetAuthContext({
      userGuid: getStaffGuid(),
      projectGuid: getProjectGuid() || 'ALL'
    })
    authState.context = ctx
    if (ctx.currentProjectGuid) setProjectGuid(ctx.currentProjectGuid)
    else if (ctx.canViewAllProjects) setProjectGuid(null)
    return ctx
  } finally {
    authState.loading = false
  }
}

export function installProjectAuth(http, apiGetAuthContext) {
  http.interceptors.request.use(config => {
    config.headers = config.headers || {}
    const sg = getStaffGuid()
    if (sg) config.headers['user-guid'] = sg
    const pg = getProjectGuid()
    if (pg) config.headers['leasing-project-guid'] = pg
    return config
  })
  return { loadContext: () => loadContext(apiGetAuthContext) }
}

export default {
  authState,
  getStaffGuid, setStaffGuid, getProjectGuid, setProjectGuid,
  getContext, clearContext, loadContext, installProjectAuth
}
